import React from "react"
import {Grid} from "@mui/material"
import Content from "../../components/Content"
import PropTypes from "prop-types"
import {checkConditionsForHidden, checkVisibility } from "../../misc/precondition-evaluation"
import {muiGridPrototypes, muiGridPrototypesDefaults} from "./ContainerManagedFlex/mui-grid-prototypes"

export const containerFlexPrototype = [
    muiGridPrototypes.direction,
    muiGridPrototypes.justifyContent,
    muiGridPrototypes.alignItems,
    muiGridPrototypes.wrap,
    {
        key: "spacing",
        type: "INTEGER",
        label: "Spacing in Pixel",
        size: 3,
    },
    {
        key: "rowSpacing",
        type: "INTEGER",
        label: "Row Spacing (vertikal) in Pixel",
        size: 3,
    },
    {
        key: "columnSpacing",
        type: "INTEGER",
        label: "Column Spacing (horizontal) in Pixel",
        size: 3,
    },
    {
        key: "sizeXs",
        type: "INTEGER",
        label: "Children Size XS",
        size: 3,
    },
    {
        key: "sizeSm",
        type: "INTEGER",
        label: "Children Size SM",
        size: 3,
    },
    {
        key: "sizeMd",
        type: "INTEGER",
        label: "Children Size MD",
        size: 3,
    },
    {
        key: "sizeLg",
        type: "INTEGER",
        label: "Children Size LG",
        size: 3,
    },
    {
        key: "sizeXl",
        type: "INTEGER",
        label: "Children Size XL",
        size: 3,
    },
]

const getSizeValue = (size) => {
    if (size === undefined) return undefined
    const castedSize = Number.parseInt(size)
    if (castedSize >= 1 && castedSize <= 12) return castedSize
    return undefined
}

const generateSizeObject = (container) => ({
    xs: getSizeValue(container.sizeXs),
    sm: getSizeValue(container.sizeSm),
    md: getSizeValue(container.sizeMd),
    lg: getSizeValue(container.sizeLg),
    xl: getSizeValue(container.sizeXl),
})

const ContainerFlex = ({container, disabled, getDataFromPointer}) => {
    const {
        padding,
        flexGrow,
        margin,
        minWidth,
        maxWidth,
        minHeight,
        direction = muiGridPrototypesDefaults.direction,
        justifyContent = muiGridPrototypesDefaults.justifyContent,
        alignItems = muiGridPrototypesDefaults.alignItems,
        wrap = muiGridPrototypesDefaults.wrap,
        spacing = "8",
        rowSpacing = "16",
        columnSpacing = "32",
    } = container
    return (
        <Grid
            container
            padding={padding}
            flexGrow={flexGrow}
            margin={margin}
            maxWidth={maxWidth}
            minWidth={minWidth}
            minHeight={minHeight ?? undefined}
            width="100%"
            display="flex"
            justifyContent={justifyContent}
            alignItems={alignItems}
            direction={direction}
            wrap={wrap}
            spacing={`${spacing}px`}
            rowSpacing={
                rowSpacing !== undefined ? `${rowSpacing}px` : undefined
            }
            columnSpacing={
                columnSpacing !== undefined ? `${columnSpacing}px` : undefined
            }>
            {container.children.map(
                (child) =>
                    !checkConditionsForHidden(child, getDataFromPointer) && (
                        <Grid
                            key={child.id}
                            size={generateSizeObject(container)}>
                            <Content
                                child={child}
                                disabled={disabled}
                            />
                        </Grid>
                    ),
            )}
        </Grid>
    )
}

ContainerFlex.propTypes = {
    container: PropTypes.shape({
        direction: PropTypes.string,
        justifyContent: PropTypes.string,
        alignItems: PropTypes.string,
        spacing: PropTypes.string,
        rowSpacing: PropTypes.string,
        columnSpacing: PropTypes.string,
        sizeXs: PropTypes.string,
        sizeSm: PropTypes.string,
        sizeMd: PropTypes.string,
        sizeLg: PropTypes.string,
        sizeXl: PropTypes.string,
    }),
    disabled: PropTypes.bool,
}

export default ContainerFlex
